import {Box} from '@jobseeker/lotus/foundations';
import {Image} from '@jobseeker/lotus/components/Image';

import type {BoxProps} from '@jobseeker/lotus/foundations';
import type {ImageProps} from 'next/image';

export interface Props extends BoxProps {
  imageSpec?: ImageProps;
  imgStyle?: object;
  boxProps?: BoxProps;
}

const ImageHolder = (props: Props) => {
  const {
    imageSpec = {src: '', alt: ''},
    imgStyle = {},
    boxProps = {},
  } = props || {};

  return (
    <Box {...boxProps}>
      <Image {...imageSpec} style={imgStyle} />
    </Box>
  );
};

export default ImageHolder;
